import React, { useEffect, useState } from "react";
import { PlusIcon } from "../../assets/Icons";
import AddDirectoryApplicationDirect from "../../Modals/AddDirectoryApplicationDirect";
import { getPlaceholderName } from "../../utils/general";
import apiClient from "../../apiClient";
import { SSO_URL } from "../../env";
import { FETCH_DIRECTORY_APPLICATIONS } from "../../apiClient/apiEndpoints";
import { useNavigate, useParams } from "react-router-dom";

const DirectoryAppList = ({ directoryDetails }) => {
  const { id } = useParams();
  const [openModal, setOpenModal] = useState(false);
  const [applications, setApplications] = useState([]);
  const navigate = useNavigate();

  const fetchDirectoryApplications = async () => {
    try {
      const res = await apiClient.get(`${SSO_URL}${FETCH_DIRECTORY_APPLICATIONS}/${id}`);
      setApplications(res.applications);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchDirectoryApplications();
  }, []);

  return (
    <>
      <div className="page-title childparents">
        <h5>Application List</h5>
        <button className="DefaultRedBtn" onClick={() => setOpenModal(true)}>
          <PlusIcon />
          Add Application
        </button>
      </div>

      <div className="table-responsive machinelist workflowtb mt-2">
        <table className="table align-middle table-nowrap mb-0">
          <thead>
            <tr>
              <th className="text-center">S.NO</th>
              <th>Application Name</th>
            </tr>
          </thead>
          <tbody>
            {applications?.map((item, index) => {
              return (
                <tr>
                  <td className="text-center"> {index + 1} </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      navigate(`/dashboard/directories/application/${id}/${item?.uuid}`, {
                        state: { directoryName: directoryDetails?.name, applicationName: item.name, icon: item.icon },
                      })
                    }
                  >
                    <div className="d-flex align-items-center gap-1">
                      {<DisplayImage path={item.icon} name={item.name} />}
                      {item?.name}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <AddDirectoryApplicationDirect
        alreadyAssignApplications={applications}
        fetchDirectoryApplications={fetchDirectoryApplications}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </>
  );
};

export default DirectoryAppList;

export const DisplayImage = ({ path = null, name = "" }) => {
  const [error, setError] = useState(false);
  return (
    <>
      {path && !error ? (
        <img class="appimage-small" src={path} onError={() => setError(true)} />
      ) : (
        <span className="initial-small">{getPlaceholderName(name)}</span>
      )}
    </>
  );
};
